(() => {
  if (window.__TKF_DISCOUNT_ENTRY_BOUND__) return;
  window.__TKF_DISCOUNT_ENTRY_BOUND__ = true;
  const noticeSelector = '[data-tkf-discount-notice]';
  const widgetSelector = '.ecomsend__Popover__Widget__Text';
  const successCookiePattern = /(?:^|;\s*)[^=;]*pp_success_subscribed[^=;]*=true(?:;|$)/;
  const hasSubscribed = () => successCookiePattern.test(document.cookie);
  let appRoot = null;
  let entryReady = false;
  let refreshQueued = false;

  // Ecomsend owns the form and subscription; this adapter only exposes its entry.
  const syncDiscountNotice = () => {
    const widget = appRoot?.querySelector(widgetSelector);
    const subscribed = hasSubscribed();
    if (widget) {
      if (widget.textContent !== '%15 İNDİRİM Kazanın') {
        widget.textContent = '%15 İNDİRİM Kazanın';
      }
      entryReady = true;
      document.documentElement.classList.add('tkf-discount-adapter-ready');
    }
    document.querySelectorAll(noticeSelector).forEach((notice) => {
      notice.hidden = subscribed || !entryReady;
    });
    return subscribed;
  };

  const queueRefresh = () => {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(() => {
      refreshQueued = false;
      syncDiscountNotice();
    });
  };

  const appObserver = new MutationObserver(queueRefresh);
  const bindApp = () => {
    const root = document.querySelector('.EcomSendAPP');
    if (!root) return false;
    appRoot = root;
    appObserver.observe(appRoot, { childList: true, subtree: true, characterData: true });
    syncDiscountNotice();
    return true;
  };

  // Stop scanning the full document as soon as the app has mounted.
  const mountObserver = new MutationObserver(() => {
    if (bindApp()) mountObserver.disconnect();
  });
  if (!bindApp()) {
    mountObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-tkf-discount-trigger]');
    if (!trigger || hasSubscribed()) return;
    const widget = appRoot?.querySelector(widgetSelector);
    if (widget) widget.click();
  });

  // The app writes this cookie after a successful subscription without a reload.
  let checksRemaining = 180;
  const timer = window.setInterval(() => {
    if (syncDiscountNotice() || checksRemaining-- <= 0) window.clearInterval(timer);
  }, 1000);
  document.addEventListener('shopify:section:load', queueRefresh);
  window.addEventListener('pagehide', (event) => {
    if (event.persisted) return;
    mountObserver.disconnect();
    appObserver.disconnect();
    window.clearInterval(timer);
  });
})();
